<template>
	<section class="container container--small module-margin" v-if="data && data.content">
		<HtmlContent class="no-padding" :html="data.content" />
	</section>
</template>

<script>
import HtmlContent from '@/components/elements/HtmlContent'

export default {
	props: ['data'],
	components: {
		HtmlContent,
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';

.module-content_block {
}
</style>
